<template>
  <div>
    <MyLabelTrueFalse v-model="value" trueText="啟用中" falseText="停用中"></MyLabelTrueFalse>
  </div>
</template>

<script>/**
 <MyLabelTrueFalse v-model="item.IsEnable"></MyLabelTrueFalse>
 <MyLabelTrueFalse v-model="item.IsEnable" :trueText="是" :falseText="否" ></MyLabelTrueFalse>
 **/
import MyLabelTrueFalse from "@/pages/commonComponent/MyLabelTrueFalse.vue";


export default {
  components: {MyLabelTrueFalse},
  // name: "MyColorPicker",
  props: {
    value: {
      type: Boolean,
    },
  },
  data: function () {
    return {
      id: "",
      formData: {
        name: "",
      },
      propsValue:this.value,
    };
  },
  watch: {
    propsValue(newVal){
      this.$emit('input', newVal);
    },
    value(newVal){
      this.propsValue = newVal
    }
  },
  methods: {
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    disable(){
      this.value=false;
    },
    enable(){
      this.value=true;
    }
  },
  mounted() {
    //this.loadData()
  },
}
</script>

<style scoped>

</style>
